import { render, staticRenderFns } from "./UsuariosLista.vue?vue&type=template&id=2304ca68&"
import script from "./UsuariosLista.vue?vue&type=script&lang=ts&"
export * from "./UsuariosLista.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports